import { defineComponent as _defineComponent } from 'vue'
import { ReferralLinks } from '@busy-human/opt-library'
import textfield from "@busy-human/vue-component-library/components/text-field.vue"
import {onMounted, ref} from 'vue'
type Props = {
    referral: ReferralLinks.Model
}
type Emits = {
    (e: 'update:referral', referral: ReferralLinks.Model): void
    (e: 'progress'): void
    (e: 'previous'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'referral-email',
  props: {
    referral: null
  },
  emits: ["update:referral", "progress", "previous"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:referral', referral: ReferralLinks.Model): void
    (e: 'progress'): void
    (e: 'previous'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    referral: ReferralLinks.Model
}





const name = ref(props.referral.addressedTo)
const email = ref(props.referral.addressedTo)

const previous = () =>{
    emit('previous')
}

const progress = () => {
    emit('update:referral', {...props.referral, addressedTo: name.value, email: email.value})
    emit('progress');
}


const __returned__ = { props, emit, name, email, previous, progress, ReferralLinks, textfield, onMounted, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})